<template>
  <div class='supplier-highWay' v-loading='importLoading'>
    <div class='nav'>
      <el-form :model='form' label-width='85px' :inline='true' class='demo-form-inline flex1'>
        <el-form-item label='供应商:'>
          <el-input v-model='form.supplier' size='mini' placeholder='请输入供应商'></el-input>
        </el-form-item>
        <el-form-item label='委托商:'>
          <el-input v-model='form.consignorName' size='mini' placeholder='请输入委托商'></el-input>
        </el-form-item>
        <el-form-item label='批次号:'>
          <el-input v-model='form.batch' size='mini' placeholder='请输入批次号'></el-input>
        </el-form-item>
        <el-form-item label='运单编号:'>
          <el-input v-model='form.waybill' size='mini' placeholder='请输入运单编号'></el-input>
        </el-form-item>
        <el-form-item label='车架号:'>
          <el-input v-model='form.frame' size='mini' placeholder='请输入车架号'
                    @paste.native.capture.prevent="(value)=>{ return searchCopyFormat(value,'frame')}"
          ></el-input>
        </el-form-item>
        <el-form-item label='品牌:'>
          <el-input v-model='form.brand' size='mini' placeholder='请输入品牌名称'></el-input>
        </el-form-item>
        <el-form-item label='台账月:'>
          <el-input v-model='form.month' size='mini' placeholder='请输入台账月'></el-input>
        </el-form-item>
        <el-form-item label='原结算对账编号：' label-width="130px">
          <el-input v-model='form.actNoSub' size='mini' placeholder='请输入原结算对账编号'  style="width: 170px"/>
        </el-form-item>
        <el-form-item label='原结算对账标题：' label-width="130px">
          <el-input v-model='form.titleSub' size='mini' placeholder='请输入原结算对账标题' />
        </el-form-item>
        <el-form-item label='计划日期:'>
          <el-date-picker
            v-model="form.planTime"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini">
          </el-date-picker>
          <el-date-picker v-if="false" v-model='form.planTime[0]' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='dateChange1' type='date'
                          placeholder='开始日期'/>
          <span v-if="false" style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
          <el-date-picker v-if="false" v-model='form.planTime[1]' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='dateChange1' type='date'
                          placeholder='结束日期'/>
        </el-form-item>
        <el-form-item label='交车日期：'>
          <el-date-picker
            v-model="form.dealer"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini">
          </el-date-picker>
          <el-date-picker v-if="false" v-model='form.dealer[0]' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='dateChange2' type='date'
                          placeholder='开始日期'/>
          <span v-if="false" style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
          <el-date-picker v-if="false" v-model='form.dealer[1]' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='dateChange2' type='date'
                          placeholder='结束日期'/>
        </el-form-item>
        <el-form-item label='是否生成对账单:' label-width='130px'>
          <el-select v-model='form.isRecon' filterable size='mini'
                     placeholder='请选择是否生成对账单'>
            <el-option label='全部' value=''></el-option>
            <el-option label='是' value='1'></el-option>
            <el-option label='否' value='0'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' type='primary' @click='addBtn'>生成对账单</el-button>
          <el-button size='small' type='primary' @click='refreshBtn'>刷新补结算</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span @click='download' class='pointer'>模板下载</span>
        <span style='cursor: pointer;display: inline-block;'>
        <import-statement @getList='_supplierLinePageList(0)'
                          @changeImportLoading='changeImportLoading' :type='23'/>
        </span>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          tooltip-effect='dark'
          ref='multipleTable'
          @select='handleCurrentChange'
          @select-all='handleCurrentChangeAll'
          :reserve-selection='true'
          :row-key='(row)=>{return row.id}'
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{height:'42px',}"
          :row-style="rowStyle"
        >
          <el-table-column type='selection' align='center' width='50px'
                           :selectable='(row,index)=>{return row.isReconciliation !==1}'
                           :reserve-selection='true'/>
          <el-table-column prop='supplierName' label='供应商' align='center' width='160px'
                           show-overflow-tooltip/>
          <el-table-column prop='consignorName' label='委托商' align='center' width='160px'
                           show-overflow-tooltip/>
          <el-table-column prop='batchNumber' label='批次号' align='center' width='150px'
                           show-overflow-tooltip/>
          <el-table-column prop='waybillNo' label='运单编号' align='center' width='150px'
                           show-overflow-tooltip/>
          <el-table-column prop='frameNumber' label='车架号' align='center' width='150px'
                           show-overflow-tooltip/>
          <el-table-column prop='brandName' label='品牌' align='center' width='150'
                           show-overflow-tooltip/>
          <el-table-column prop='modelName' label='型号' align='center' width='150'
                           show-overflow-tooltip/>
          <el-table-column prop='standingBookMonth' label='台账月' align='center' width='100'
                           show-overflow-tooltip/>
          <el-table-column prop='receiptManageNumber' label='交单编号' align='center' width='130'
                           show-overflow-tooltip/>
          <el-table-column prop='plannedDate' label='计划日期' align='center' width='100%'>
            <template slot-scope='scope'>{{ scope.row.plannedDate|formatTime }}</template>
          </el-table-column>
          <el-table-column prop="shippingDate" label="发运日期" align="center" width="120" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.shippingDate | formatTime }}</template>
          </el-table-column>
          <!-- <el-table-column prop="shippingDate" label="发运日期" align="center" width="120" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.shippingDate|formatTime}}</template>
          </el-table-column> -->
          <el-table-column prop='deliveryDate' label='交车日期' align='center' width='120'
                           show-overflow-tooltip>
            <template slot-scope='scope'>{{ scope.row.deliveryDate|formatTime }}</template>
          </el-table-column>
          <el-table-column width='160' label='起始地' align='center' show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.startType == 0 ? scope.row.startName : scope.row.startPortName }}
            </template>
          </el-table-column>
          <el-table-column width='160' label='交车地' align='center' show-overflow-tooltip>
            <template slot-scope='scope'>
              {{
                scope.row.deliveryType == 0 ? scope.row.deliveryName : scope.row.deliveryPortName
              }}
            </template>
          </el-table-column>
          <el-table-column prop='taxRate' label='税率(%)' align='center'/>
          <el-table-column prop='difPrice' label='差价' align='center' show-overflow-tooltip/>
          <el-table-column prop='taxContractPrice' label='含税合同价' align='center'/>
          <el-table-column prop='taxPreparePrice' label='含税预结算价' align='center'/>
          <el-table-column prop='isReconciliation' label='生成对账单' align='center'>
            <template slot-scope='scope'>{{ scope.row.isReconciliation |isReconciliationFormat }}
            </template>
          </el-table-column>
          <el-table-column prop='actNo' label='对账单编号' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='title' label='对账单标题' width='180px' align='center'
                           show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.title ? scope.row.title : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop='actNoSub' label='原结算对账编号' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='titleSub' label='原结算对账标题' width='160px' align='center'
                           show-overflow-tooltip/>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[50, 100, 500, 1000,2000]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='form.page'
          :page-size='form.rows'
        />
      </div>
    </div>
    <el-dialog :title=" importShow ?'导入生成对账单':'生成对账单'" :visible.sync='addFlag'
               :width='dialogWith'
               center @close='dialogClose'>
      <!-- check-table-data 传入需要展示的数据
        importShow  判断是否是导入生成对账单or 生成对账单
        selectionTable 运单费用操作删除触发  传出删除后数据据 多选表格联动 重新勾选 -->
      <accountAddState
        :check-table-data='JSON.parse(JSON.stringify(checkTableDataProps))'
        :importShow='importShow'
        :dialog-close-parent='dialogClose'
        :settlement='settlement'
        @selectionTable='selectChange'
        ref='accountAddState'>
        <template slot='label'>基础信息</template>
        <template slot='label2'>运单费用</template>
      </accountAddState>
    </el-dialog>
  </div>
</template>

<script>
import {supplierLinePage, supplierLinePageList} from '@/service/getData';
import {formatTime, getSessionStore} from '@/config/mUtils';
import {
  addSettlementFreight, refreshAddSupplier,

  refreshSupplier, supplierLineAddPriceRefresh, supplierLinePriceRefresh,
  updateStandingBook,
} from '@/service/basicfile';
import accountAddState from './accountAddState.vue';
import {baseUrl} from '@/config/env';
import ImportStatement from '@/views/settle/entrust/components/import-statement';

export default {
  components: {
    ImportStatement,
    accountAddState,
  },
  data() {
    return {
      form: {
        supplier: '', // 供应商
        consignorName: '', // 委托商
        batch: '', // 批次号
        waybill: '', // 运单编号
        frame: '', // 车架号
        brand: '', // 品牌
        month: '', // 台账月
        actNoSub: '', //原对账编号
        planTime: ['', ''], // 计划日期
        dealer: ['', ''], // 交车日期
        isRecon: '', // 是否生成账单
        title:'',
        titleSub: '',
        page: 1,
        rows: 50,
      },
      total: 0,
      tableLoad: false,
      TableDatas: [],
      checkList: [], // 导入生成账单 选择数据
      billTitle: '',
      checkLoad: false,
      checkTableDataProps: [], // 传入需要展示的数据
      visible: false, // 导入生成账单 显示
      importShow: false,
      stepData: [],

      addFlag: false,
      dialogWith: '950px',
      name: '',
      rules: {
        plan: {
          required: true,
          message: ' ',
          trigger: 'blur',
        },
        name: [
          {
            required: true,
            message: '请输入业务名称',
            trigger: 'blur',
          },
          {
            min: 3,
            max: 9,
            message: '长度在 3 到 9 个字符',
            trigger: 'blur',
          },
        ],
        content: {
          required: true,
          message: '请输入评审需求',
          trigger: 'blur',
        },
        type: {
          required: true,
          message: '请选择评审类型',
          trigger: 'blur',
        },
        img: {
          required: true,
          message: '请选择合同照片',
          trigger: 'blur',
        },
      },
      settlement: '', // 生成对账单时的结算方式

      // 修改台账月
      ledgerVisible: false,
      ledgerLoad: false,
      ledger: '',
      ledgerData: [],
      importLoading: false,
    };
  },
  computed: {
    stepState() {
      return function (state) {
        switch (state) {
          case '':
            return 'wait';
          case 'success':
            return 'success';
          case 'failure':
            return 'error';
        }
      };
    },
  },
  filters: {
    isReconciliationFormat(value) {
      switch (value) {
        case 0:
          return '否';
        case 1:
          return '是';
      }
    },
    formatTime(val) {
      if (val) {
        return formatTime(val, 'yyyy-mm-dd ');
      }
      return '';
    },
  },
  mounted() {
    // 0 公路 1 水路
    // this._supplierLinePageList(0);
  },
  methods: {
    refreshBtn(){
      this.refresh(0)
    },
    // 导出数据
    exportData() {
      let token = getSessionStore('token');
      const exportParams = {
        supplierType: 0,
        supplierName: this.form.supplier,
        consignorName: this.form.consignorName,
        batchNumber: this.form.batch,
        waybillNo: this.form.waybill,
        frameNumber: this.form.frame,
        brandName: this.form.brand,
        standingBookMonth: this.form.month,
        planStartDate: this.form.planTime[0] || '',
        planEndDate: this.form.planTime[1] || '',
        deliveryStartDate: this.form.dealer[0] || '',
        deliveryEndDate: this.form.dealer[1] || '',
        isReconciliation: this.form.isRecon,
        title:this.form.title,
      }
      window.exportExcel(`${baseUrl}/platform/settlement/supplierLine/add/exportXls?access_token=${token}`, exportParams, '供应商公路托运费补结算');

    },
    // 分页查询
    async _supplierLinePageList(supplierType) {
      const {
        supplier,
        consignorName,
        isRecon,
        batch,
        page,
        rows,
      } = this.form;
      this.tableLoad = true;
      const res = await supplierLinePage({
        supplierType,
        supplierName: supplier,
        consignorName: consignorName,
        batchNumber: batch,
        waybillNo: this.form.waybill,
        frameNumber: this.form.frame,
        brandName: this.form.brand,
        standingBookMonth: this.form.month,
        planStartDate: this.form.planTime[0] || '',
        planEndDate: this.form.planTime[1] || '',
        deliveryStartDate: this.form.dealer[0] || '',
        deliveryEndDate: this.form.dealer[1] || '',
        isReconciliation: isRecon,
        actNoSub: this.form.actNoSub,
        titleSub: this.form.titleSub,
        page,
        rows,
      });
      this.tableLoad = false;
      if (res.status !== 0) return this.$message.error(res.message);
      this.TableDatas = res.data.records;
      this.total = res.data.total;
    },
    // 生成对账单按钮
    addBtn() {
      if (this.checkTableDataProps.length <= 0) return this.$message.warning('请至少选择一条结算数据！');
      let supplierFlag = false; // 供应商
      let taxFlag = false; // 税率
      let reconciliationFlag = false; // 是否生成对账单
      if (this.checkTableDataProps.length > 0) {
        const {
          supplierId,
          taxRate,
        } = this.checkTableDataProps[0];
        this.checkTableDataProps.forEach((item) => {
          if (item.supplierId !== supplierId) {
            supplierFlag = true;
          }
          if (item.taxRate !== taxRate) {
            taxFlag = true;
          }
          if (item.isReconciliation) {
            reconciliationFlag = true;
          }
        });
      }
      if (supplierFlag) return this.$message.warning('只能选择同一家供应商数据！');
      if (reconciliationFlag) return this.$message.warning('部分数据已生成对账单！');
          let type = false;
          this.checkTableDataProps.forEach((item) => {
            if (!item.taxContractPrice || item.taxContractPrice == '' || !item.contractPrice || item.contractPrice == '') {
              type = true;
            }
          });
          // 生成对账单弹窗显示
          this.settlement === 1
          this.addFlag = true;
          this.$nextTick(() => {
            this.$refs.accountAddState.init(this.checkTableDataProps);
          });
          // 判断是否是导入生成对账单
          this.importShow = false;
    },
    // 查询
    searchBtn() {
      this.form.page = 1;
      this._supplierLinePageList(0);
    },
    // 重置
    resetBtn() {
      for (const argumentsKey in this.form) {
        this.form[argumentsKey] = '';
      }
      this.form.page = 1;
      this.form.rows = 10;
    },
    //刷新补结算
    async refresh(supplierType) {
      const {
        supplier,
        consignorName,
        batch,
      } = this.form;
      this.tableLoad = true;
      const res = await refreshAddSupplier({
        supplierType,
        supplierName: supplier,
        consignorName: consignorName,
        batchNumber: batch,
        waybillNo: this.form.waybill,
        frameNumber: this.form.frame,
        brandName: this.form.brand,
        standingBookMonth: this.form.month,
        planStartDate: this.form.planTime[0] || '',
        planEndDate: this.form.planTime[1] || '',
        deliveryStartDate: this.form.dealer[0] || '',
        deliveryEndDate: this.form.dealer[1] || '',
        isReconciliation: '',
        actNoSub: this.form.actNoSub,
        titleSub: this.form.titleSub,
      });
      this.tableLoad = false;
      if (res.status !== 0) return this.$message.error(res.message);
      await this._supplierLinePageList(0)
    },
    contractSizeChange(row) {
      this.form.rows = row;
      this._supplierLinePageList(0);
    },
    contractCurrentChange(page) {
      this.form.page = page;
      this._supplierLinePageList(0);
    },
    // 计划开始-结束日期验证
    dateChange1(val) {
      if (this.form.planTime[1] && this.form.planTime[0] && (this.form.planTime[1] <= this.form.planTime[0])) {
        if (val == this.form.planTime[1]) this.form.planTime[1] = '';
        if (val == this.form.planTime[0]) this.form.planTime[0] = '';
        this.$forceUpdate();
        return this.$message.warning('结束日期必须大于开始日期！');
      }
    },
    // 交车开始-结束日期验证
    dateChange2(val) {
      if (this.form.dealer[1] && this.form.dealer[0] && (this.form.dealer[1] <= this.form.dealer[0])) {
        if (val == this.form.dealer[1]) this.form.dealer[1] = '';
        if (val == this.form.dealer[0]) this.form.dealer[0] = '';
        this.$forceUpdate();
        return this.$message.warning('结束日期必须大于开始日期！');
      }
    },
    getSummaries(param) {
      const {
        columns,
        data,
      } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
        } else if (index >= 11) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => prev + curr, 0);
          }
        }
      });
      return sums;
    },
    // 导入
    // importClick(index, row) {
    //   if (this.checkList.length < 3) return this.$message.warning('至少选择三个条件');
    //   this.visible = false;
    //   this.importShow = true;
    //   this.addFlag = true;
    // },
    tableRowClassName({row}) {
      if (row.remark === '价格异常') return 'ui-warning-row';
      return '';
    },
    // 多选事件触发
    handleCurrentChange(val) {
      this.checkTableDataProps = val;
      let Waybill = '';
      if (val.length > 0) {
        const array = val.filter((item, index) => {
          // 取第一行
          if (index === 0) Waybill = item.supplierName;
          // 赛选不等于第一行的数据
          return Waybill !== item.supplierName;
        });
        // 筛选  供应商相同数据
        this.checkTableDataProps = val.filter(item => Waybill === item.supplierName);
        // 与第一行不相等的数据
        array.forEach((value) => {
          // 只有使用表格原数据，才会生效   从表格原数据中赛选
          this.$message.warning('只能选择相同的供应商');
          this.$refs.multipleTable.toggleRowSelection(this.TableDatas.find(item => value.id === item.id), false);
        });
      }
    },
    rowStyle({ row }) {
      return this.checkTableDataProps.includes(row) ? { background: 'rgb(197 226 255)' } : {};
    },
    handleCurrentChangeAll(val) {
      this.checkTableDataProps = val;

      // this.$refs.accountState.calculation()
    },
    // 子组件 表格勾选触发
    selectChange(val) {
      // 先清空选择
      this.$refs.multipleTable.clearSelection();
      // 将子组件表格数据赋值。
      this.checkTableDataProps = val;
      this.$nextTick(() => {
        val.forEach((row) => {
          // 只有使用表格原数据，才会生效   从表格原数据中赛选  重新勾选
          this.$refs.multipleTable.toggleRowSelection(this.TableDatas.find(item => row.id === item.id));
        });
      });
    },
    dialogClose() {
      this.$refs.accountState.activeName = 'information';
      this.name = 'information';
      this.addFlag = false;
    },
    selectable(row, index) {
      return row.isReconciliation === 1;
    },
    download() {
      window.location.href = '/file/供应商导入模板（含结算方式）.xlsx';
    },
    changeImportLoading(flag) {
      this.importLoading = flag;
    },
    searchCopyFormat(value, flag) {
      let splitArr = value.clipboardData.getData('Text')
        .replace(/\s/g, ',')
        .split(',');
      splitArr = splitArr.filter(item => item);
      splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
      switch (flag) {
        case 'frame':
          this.form.frame = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
          break;
      }
    },
  },
};
</script>


<style lang='scss' scoped>
.supplier-highWay {
  width: 100%;
  /*padding:20px 15px 0 25px;*/
  height: 100%;

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      margin-right: 10px;
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }

  ::v-deep .el-table__header .has-gutter tr .el-table-column--selection .cell .el-checkbox::after {
    color: #606266;
    content: "全选";
    font-size: 12px;
    margin-left: 2px;

  }

  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;

    .navContainer {
      display: inline-block;

      p {
        display: inline-block;
        width: 80px;
        text-align: right;
      }
    }

    .flex1 {
      flex: 1;
    }

    .el-input {
      width: 150px;
    }

    .el-select {
      width: 150px;
    }

    .el-form-item {
      margin-bottom: 5px;
    }

    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
        line-height: 30px;
      }

      .el-form-item__content {
        line-height: 30px;
      }
    }
    .ml10 {
      ::v-deep  .upload-demo{
        margin: -32px 400px;
      }
    }
  }

  .ledger {
    padding: 20px;

    .leader-input {
      display: inline-block;
      width: 100%;
      margin-bottom: 15px;

      span {
        display: inline-block;
        width: 100px;
      }

      ::v-deep {
        .el-input.el-input--small {
          display: inline-block;
          width: 200px;
        }
      }
    }

    ::v-deep {
      .el-table td {
        padding: 5px;
      }

      .el-table td, .el-table th {
        font-size: 13px;
        padding: 5px;
      }
    }
  }

  ::v-deep.content {
    .el-table th > .cell {
      font-weight: 700 !important;
    }

    .el-table .cell, .el-table td {
      padding: 0;
    }
  }

  ::v-deep .importBill {
    width: 100%;
    padding: 10px 0 20px 20px;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .el-table td, .el-table th {
      padding: 0;
    }

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        /*padding:20px 23px 0 23px;*/
        padding-right: 20px;
        margin-top: 20px;
        font-size: 14px;

        .el-table .ui-warning-row {
          background-color: #fef0f0 !important;
        }

        .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover > td {
          background-color: #fef0f0 !important;
        }

        .el-table .ui-warning-row .cell {
          color: red;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }

        .iconError {
          font-size: 15px;

          i:hover {
            color: #00e1ff;
          }
        }


      }
    }

    .operation {
      display: flex;
      flex-direction: column;
      margin-top: 20px;

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      .cell {
        font-size: 10px;
        padding: 0;
      }

      &Table {
        width: 100%;
        margin-top: 10px;
        padding-right: 20px;

        .el-button--mini {
          padding: 4px 4px;
        }
      }
    }
  }

  ::v-deep .add {


    font-weight: 700;
    width: 100%;

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Input {
        display: flex;
        height: 30px;
        line-height: 30px
      }

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;
        font-size: 14px;

        .el-table td, .el-table th {
          padding: 0;
        }

        .iconError {
          font-size: 20px;

          i:hover {
            color: #00e1ff;
          }
        }

        .yang {
          .el-form-item {

            margin-bottom: 15px;

            .el-form-item__label {
              /*width: 150px !important;*/
              /*color: #060606;*/
            }

            .el-input {
              width: 430px;
            }

            .el-textarea {
              width: 250px;

            }
          }

        }

      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 13px;
      margin-top: 20px;

      button {
        margin: 0 15px;
      }
    }
  }

  ::v-deep {
    .el-table td {
      font-size: 13px;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      overflow: auto;
      max-height: 75vh;
      color: #606266;
    }

  }

}

</style>
